<template>
    <div class="atelier-swipper-container">
        <div class="atelier-swipper-title">
            <CommonComponentsProductsTitleTopicTitle :topic-title="topicTitle" :color-index="colorIndex" />
        </div>
        <div class="atelier-swipper-content">
            <!-- <img :src="image.bg" alt="" class="atelier-bg" /> -->
            <div class="atelier-colortext">
                <span class="atelier-purpletext">{{ $t(data.purpleText) }}</span>
                <span class="atelier-greentext">{{ $t(data.greenText) }}</span>
            </div>
            <img :src="data.woman" alt="" class="atelier-woman" />
            <div class="atelier-covertext">
                <span class="atelier-whitetext">{{ $t(data.whiteText) }}</span>
            </div>
            <!-- <img :src="image.glassmobile" alt="" class="atelier-glassmobile" /> -->
        </div>
    </div>
</template>

<script setup lang="ts">
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import woman from '@assets/imgs/Products/AtelierSimulator/Swipper/bg.png';
    gsap.registerPlugin(ScrollTrigger);

    const data = reactive({
        woman,
        purpleText: 'global_atelier_swipper_purpletext',
        greenText: 'global_atelier_swipper_greentext',
        whiteText: 'global_atelier_swipper_whitetext',
    });
    const colorIndex = 3;
    const topicTitle: FunctionTitle = {
        title: 'global_swipper_title',
        colorTitle: 'global_atelier_swipper_colorTitle_3',
        subTitle: 'global_atelier_swipper_subTitle_3',
    };
    onMounted(() => {
        // addFadeIn('.atelier-woman ');

        gsap.timeline({
            scrollTrigger: {
                // markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
                trigger: '.atelier-swipper-container',
                // scrub: true,
                start: 'top center',
                end: '70% top',
            },
        })
            .fromTo(
                '.atelier-colortext',
                {
                    scale: 0.9,
                    webkitClipPath: 'inset(0%  100% 0% 0%)',
                },
                {
                    scale: 1,
                    webkitClipPath: 'inset(0%  0% 0% 0%)',
                    duration: 1,
                },
            )
            .to(
                '.atelier-woman',
                {
                    opacity: 1,
                    duration: 1,
                },
                '-=0.2',
            );

        addTextScrollLine(
            '.atelier-covertext',
            {
                backgroundImage:
                    'linear-gradient(75deg,rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 33.3%,rgba(255,255,255,0) 66.7%,rgba(255,255,255,0) 100%)',
            },
            { color: 'rgba(255,255,255,0.8)' },
        );
    });
</script>

<style lang="less" scoped>
    .atelier-swipper-container {
        margin: 0 .convert(40px) [ @vw];
        @media (max-width: @screen-mobile-width) {
            width: 100vw;
            height: 100vh;
        }
        .atelier-swipper {
            &-title {
                padding-top: .convert(106px) [ @vw];
                width: 100%;
            }

            &-content {
                position: relative;
                // padding-top: .convert(100px) [ @vw];
                height: .convert(950px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    height: 45vh;
                }
                .atelier-colortext {
                    position: absolute;
                    display: flex;
                    font-family: 'BoutiqueBitmap9x9 1.5';
                    flex-direction: column;
                    font-size: .convert(250px) [ @vw];
                    line-height: 100%; //
                    font-weight: 700;
                    top: 10%;
                    .atelier-purpletext {
                        color: #ff00ff;
                    }
                    .atelier-greentext {
                        color: #00ff00;
                    }
                }
                .atelier-woman {
                    width: .convert(800px) [ @vw];
                    height: .convert(822px) [ @vw];
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    opacity: 0;
                    // display: block;
                }
                .atelier-covertext {
                    position: absolute;
                    font-family: 'BoutiqueBitmap9x9 1.5';
                    font-size: .convert(65.771px) [ @vw];
                    font-weight: 400;
                    bottom: 2%;
                    line-height: 140%; /* 92.079px */
                }

                @media (max-width: @screen-mobile-width) {
                    .atelier-covertext {
                        width: 100%;
                        // height: .convert(398px) [ @vw-mobile];
                        bottom: 0%;
                        display: none;
                    }
                }
            }
        }
    }
</style>
